import React, { CSSProperties, FC } from 'react'
import styles from '~/modules/Cards/Infrastructure/Components/CardCard.module.scss'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import { ComponentCardDto } from '~/modules/Products/Infrastructure/Dtos/ComponentCardDto'

interface Props {
  cardDto: ComponentCardDto
}

export const CardCard: FC<Props> = ({ cardDto }) => {
  const { t } = useTranslation('cards')

  return (
    <div
      className={ styles.cardCard__container }
    >
      <Link
        href={ `/cards/${cardDto.id}` }
        className={ styles.cardCard__link }
      >
        { t('show_info_button') }
      </Link>

      <div
        className={ styles.cardCard__imageWrapper }>
        <img
          className={ styles.cardCard__media }
          src={ cardDto.imageUrl }
          alt={ cardDto.description }
          style={ {
            '--bg-color': cardDto.organizer.color,
          } as CSSProperties }
        />
      </div>

      <div className={ styles.cardCard__data }>
        <div className={ styles.cardCard__organizer }>
          { cardDto.content.header }
        </div>
        <div className={ styles.cardCard__fullName }>
          { cardDto.content.subtitle }
        </div>
        <div className={ styles.cardCard__extra }>
          { cardDto.content.title }
        </div>
      </div>
    </div>
  )
}
